export default {
  firstName: '名',
  lastName: '姓',
  sendAgain: '再次发送',
  createAccount: '注册新用户',
  email: '请输入邮箱（推荐使用公司邮箱）',
  enterPassword: '设置密码',
  rePassword: '再次输入密码',
  tips: '点击“注册”或“领英登录”即代表您已阅读并同意使用条款。',
  register: '注册用户',
  success: '注册成功',
  exists: '该账号已注册，请直接登录',
  //
  backLogin: '返回登录',
  createAccount1: '注册用户',
  email1: '邮箱',
  recommendEmail: '推荐使用公司邮箱',
  setPass: '设置密码',
  showPasswordRules: '密码至少为8位字符，并同时包含字母和数字',
  confirmPass: '再次输入密码',
  or: '或者',
  linkedinLogin: '领英登录',
  inputEmail: '请输入邮箱',
  inputPhone: '请输入手机号码',
  required: '请填写验证码',
  needCanUseEmail: '必须是可用邮箱',
  needCanUsePhone: '必须是可用手机号码',
  setPassPop: '请输入密码',
  eightMinPassword: '密码最短为 8 位',
  passwordRules: '请按照要求设置密码',
  confirmPassPop: '请确认密码',
  reInputPassword: '请再次输入密码',
  noMatchPassword: '密码不一致，请重新输入',
  acceptTermsPop: '请确认用户协议',
  emailConsent: '宣传推广电子信息同意书',
  emailConsentText:
    '为确保您及时了解移动行业的最新动态，我们希望向您发送有关活动，产品，服务和倡议的信息以及行业新闻。请通过左方勾选此框来订阅; 您可以随时取消订阅电邮更新。',
  ruleLastName: '请输入您的姓氏',
  ruleFirstName: '请输入您的名字',
}
